'use client';

import { useSyncExternalStore } from 'react';

const subscribe = () => () => {};

/**
 * False while rendering on the server and hydrating, true after —
 * for output that needs the browser's DOM to build.
 * Docs: https://react.dev/reference/react/useSyncExternalStore
 */
export function useIsClient(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => true,
    () => false
  );
}
